import { useCallback, useEffect, useState } from 'react';
import { Button, Paragrapgh, Spinner, Title } from '../../components/shared';
import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { sendSingleRequest } from '../../apis';
import { translate } from '../../lib/lang.helper';
import { defaultDateFormat } from '../../lib/common.helpers';

interface INotification {
  id: number;
  title: string;
  content?: string | null;
  created_at: number;
}

const Notifications = () => {
  const lang = useSelector(selectLang);

  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState<INotification[]>([]);

  const loadData = useCallback(async () => {
    setLoading(true);
    const response = await sendSingleRequest(
      {},
      'GET',
      'api/user/reminders',
      true,
    );
    setLoading(false);
    if (!response.status) {
      window.alert(response.data?.message ?? translate(lang, 'Server error'));
      return;
    }
    setNotifications(response.data);
  }, []);

  const clearClick = async () => {
    setLoading(true);
    const response = await sendSingleRequest(
      {},
      'DELETE',
      'api/user/reminders',
      true,
    );
    if (!response.status) {
      setLoading(false);
      window.alert(response.data?.message ?? translate(lang, 'Server error'));
      return;
    }
    loadData();
  };

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <>
      <div className='h-calc-80 container w-100'>
        <div className='notifications mt-22'>
          <div className='mb-16 d-flex align-center justify-between'>
            <Title size={5} color='black-3' align='default' fontWeight={700}>
              {translate(lang, 'Notifications')}
            </Title>
            <Button
              color='blue'
              size={1}
              width='default'
              type='bordered'
              isNoneBorder
              onClick={clearClick}
              disabled={loading}
            >
              {translate(lang, 'Clear history')}
            </Button>
          </div>
          {loading ? (
            <div className='mt-32'>
              <Spinner position='local' />
            </div>
          ) : (
            <>
              {notifications &&
                notifications.map(notification => (
                  <div className='notifications__card'>
                    <Paragrapgh
                      className='mb-4'
                      size={1}
                      color='black-3'
                      align='left'
                      fontWeight={600}
                    >
                      {notification.title}
                    </Paragrapgh>
                    {!!notification.content && (
                      <Paragrapgh
                        className='mb-8'
                        size={2}
                        color='default'
                        align='left'
                        fontWeight={400}
                      >
                        {notification.content}
                      </Paragrapgh>
                    )}
                    <Paragrapgh
                      size={2}
                      color='black-2'
                      align='left'
                      fontWeight={400}
                    >
                      {defaultDateFormat(notification.created_at)}
                    </Paragrapgh>
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Notifications;
